import { render, staticRenderFns } from "./PaginationArrows.vue?vue&type=template&id=2babcc7a&scoped=true&"
import script from "./PaginationArrows.vue?vue&type=script&lang=js&"
export * from "./PaginationArrows.vue?vue&type=script&lang=js&"
import style0 from "./PaginationArrows.vue?vue&type=style&index=0&id=2babcc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2babcc7a",
  null
  
)

export default component.exports